import { AutoExposureBiProviderDisplayName } from '@dbt-labs/dbt-dag';

import { AutoExposureBiProvider } from '@/__generated__/graphql';

export function formatBiProviderName(
  biProvider: AutoExposureBiProvider | null,
): string {
  if (!biProvider) return '';
  return AutoExposureBiProviderDisplayName[biProvider];
}
